var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoobiPayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 148,
    viewBox: "0 0 115 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00206963 147.598V57.0093C0.00206963 57.0093 -1.13374 9.88042 49.8105 0H114.419V60.9546C114.419 60.9546 110.712 115.463 52.6605 113.162V81.5515L76.854 57.5621L88.2399 68.5687L88.5256 25.6753L44.8562 25.4404L56.4581 36.8685L25.7703 66.9865V122.351L0.00206963 147.598Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9121 25.3438L56.521 36.7719L25.8333 66.8899L35.4772 76.4525V118.959L52.7234 113.065V81.4549L76.9169 57.4655L88.3028 68.4721L88.5885 25.5787L44.9121 25.3438Z",
    fill: "#DA5026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoobiPayLogo);
export default __webpack_public_path__ + "static/media/MoobiPay_logo.dd3022e04ed7e38cff793fabb50186d9.svg";
export { ForwardRef as ReactComponent };